import { render, staticRenderFns } from "./Maximize.vue?vue&type=template&id=05861c7c&"
import script from "./Maximize.vue?vue&type=script&lang=js&"
export * from "./Maximize.vue?vue&type=script&lang=js&"
import style0 from "./Maximize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports